// extracted by mini-css-extract-plugin
export default {"container":"form-title_container__3Ii_9"};